import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { KalDialogConfig, KalDialogService } from '@kalidea/kaligraphi';
import {
    SharedCommentTableContainerDialogComponent,
    SharedCommentTableContainerDialogData
} from 'src/app/_shared/dialogs/shared-comment-table-container-dialog/shared-comment-table-container-dialog.component';
import { InfosFactureCommandeBeneficiairePartAChargeListingModelInput } from 'src/graphql/generated-types';

type CommentOtherType = { CommentairePublic: string; CommentairePrive: string }

@Component({
    selector: 'app-shared-comment-table-container',
    templateUrl: './shared-comment-table-container.component.html',
    styleUrls: ['./shared-comment-table-container.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedCommentTableContainerComponent {
    @Input() publicComment: string = null;

    @Input() privateComment: string = null;

    @Input() otherComment: InfosFactureCommandeBeneficiairePartAChargeListingModelInput[];

    firstLabel = 'Commande';
    secondLabel = 'Facture';

    constructor(private dialogService: KalDialogService) {
    }

    get other(): CommentOtherType {
        return (this.otherComment?.[0] || {} ) as CommentOtherType;
    }

    get hasComment(): boolean {
        return !!this.publicComment || !!this.privateComment || !!this.other.CommentairePublic || !!this.other.CommentairePrive;
    }

    openCommentTableContainer(): void {
        const config = new KalDialogConfig<SharedCommentTableContainerDialogData>({
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-dark-backdrop',
            disableClose: true,
            data: {
                commentsList: [
                    {
                        label: this.firstLabel,
                        publicComment: this.publicComment,
                        privateComment: this.privateComment,
                    },
                    {
                        label: this.secondLabel,
                        publicComment: this.other.CommentairePublic,
                        privateComment: this.other.CommentairePrive,
                    }
                ]
            }
        });

        this.dialogService.open(SharedCommentTableContainerDialogComponent, config);
    }

}
